import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';

class Dispatcher extends Component {
  goto = (newPath) => {
    browserHistory.push(newPath);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col s12 align-center">
            <h3>Dispatch</h3>
          </div>
        </div>
        <div className="row">
          <div className="col s12 m3">
            <RaisedButton primary={true} label="Inbound" fullWidth onClick={() => { this.goto('/dispatcher/inbound') }} />
          </div>
          <div className="col s12 m3">
            <RaisedButton primary={true} label="Manifests" fullWidth onClick={() => { this.goto('/dispatcher/manifests') }} />
          </div>
          <div className="col s12 m6" />
        </div>
      </div>
    );
  }
}

export default Dispatcher



// WEBPACK FOOTER //
// ./src/containers/Dispatcher/index.js